import Cookies from 'js-cookie';

const cookieService = {
  get: (key) => Cookies.get(key),
  set: (key, value, options = { expires: 7, path: '/' }) => {
    Cookies.set(key, value, options);
  },
  remove: (key, options = { path: '/' }) => {
    Cookies.remove(key, options);
  },
};

export default cookieService;
